import SSRIcon from '@ingka/ssr-icon';
import arrowRightPath from '@ingka/ssr-icon/paths/arrow-right';
import folderPath from '@ingka/ssr-icon/paths/folder';
import Text from '@ingka/text';
import { useNavigate } from 'react-router';
import { useApp } from '@/context/AppContext';
import styles from './ProductStep.module.css';

export default function ProductStep() {
  const navigate = useNavigate();
  const { catalog, setProduct } = useApp();

  // Server already filters by user scope in /auth/me, so use catalog directly
  const availableProducts = (catalog?.products ?? []).filter((p) => !p.special_route);

  const pick = (productId: string) => {
    setProduct(productId);
    navigate('/upload/entity');
  };

  return (
    <div className={styles.page}>
      <div className={styles.hero}>
        <Text tagName="h2" textStyle="Heading.XL" className={styles.heroTitle}>
          Which product is this for?
        </Text>
        <Text tagName="p" textStyle="Body.L" className={styles.heroBody}>
          Choose the product area that owns the data. This decides the schema and where the file is
          routed.
        </Text>
      </div>

      <div className={styles.grid}>
        {availableProducts.map((p) => (
          <button key={p.id} type="button" onClick={() => pick(p.id)} className={styles.card}>
            <div className={styles.cardTop}>
              <div className={styles.cardIcon}>
                <SSRIcon paths={folderPath} />
              </div>
              <SSRIcon paths={arrowRightPath} className={styles.cardArrow} />
            </div>
            <Text tagName="h3" textStyle="Heading.L" className={styles.cardName}>
              {p.name}
            </Text>
            <Text tagName="p" textStyle="Body.S" className={styles.cardDesc}>
              {p.description ?? ''}
            </Text>
          </button>
        ))}
      </div>
    </div>
  );
}
